import Vue from 'vue';
import Router from 'vue-router';
import FAQ from '@/components/FAQ.vue';
import FAQContent from '@/components/FAQContent.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/FAQContent',
    name: 'FAQContent',
    component: FAQContent
  }
];

const router = new Router({
  mode: 'history',
  routes
});

export default router;
